import React from 'react';
import styles from './challenge.module.css';
import {BiTimeFive,BiShareAlt} from 'react-icons/bi'


const Challenge =()=>{
    return(
        <div className={styles.container}>
            <div className={styles.header}>
            <div className={styles.col1}>
                <img src="https://image.freepik.com/free-vector/rock-n-roll-guitar_2150-167.jpg" alt="chal"/>
            </div>
            <div className={styles.col2}>
                <h1>Rock and Roll</h1>
                <p>sponser by : spotify</p>
                
                <div className={styles.joined}>
                    
                    <img  src="https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg"/>
                    <img  src="https://cultivatedculture.com/wp-content/uploads/2019/12/LinkedIn-Profile-Picture-Example-Tynan-Allan.jpeg"/>
                    <img  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcsjMZRq5tDcW-zaTDcZL01NOCrDYLglPqfQ&usqp=CAU"/>
                    <img  src="https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg"/>
                    <span> </span> and 278 others joined.
                </div>
                <p style={{marginLeft:"-8px",marginTop:"10px"}}> <BiTimeFive/> start on 5th march.</p>
            
            </div>
            </div>
                {/* header closed  */}
            <div className={styles.elig}>
            <h3>Description</h3>
            <p>
            it doesn't depend on version of react. its feautere of ecmascript, typescript. U can type your template in Chrome console to test if your temlate is ok. Problem can be in your babel settings also. – 
            </p>
                <h3>Eligibility</h3>
                <ul>
                    <li>Must have minimum 10 followers.</li>
                    <li>Must have minimum 100 profile visits.</li>
                </ul>
                <h3>Criteria of Winnig</h3>
                <ul>
                    <li>Must have minimum 100 profile visits.</li>
                    <li>Must have minimum 100 profile visits.</li>
                </ul>

            </div>
            <div className={styles.actionbtn}>
             <button className={styles.applybtn}>Apply Now</button>
            <button className={styles.sharebtn}><BiShareAlt/></button>
            </div>
        </div>
    )
}

export default Challenge